import { render, staticRenderFns } from "./KnowledgeUnitView.vue?vue&type=template&id=12cc5bc8&"
import script from "./KnowledgeUnitView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports